export function moverElemento(lista: any[], from: number, to: number) {
  const elemento = lista.splice(from, 1)[0];
  lista.splice(to, 0, elemento);
  return lista;
}
